// const DEV_CONFIGURATIONS = {
//     API_BASE_URL: process.env.REACT_APP_API_BASE_URL_DEV,
//     API_BASE_DOMAIN: process.env.REACT_APP_API_BASE_DOMAIN_DEV,
//     API_BASE_SOCKET_DOMAIN: process.env.REACT_APP_API_BASE_SOCKET_DOMAIN_DEV,
//     API_PAYSTACK_BASE_URL: process.env.REACT_APP_PAYSTACK_BASE_URL_DEV,
//     API_PAYSTACK_PUBLIC_KEY: process.env.REACT_APP_PAYSTACK_PUBLIC_KEY_DEV,
//     API_PAYSTACK_SECRET_KEY: process.env.REACT_APP_PAYSTACK_SECRET_KEY_DEV,
//     REACT_APP_STRIPE_API_KEY: process.env.REACT_APP_STRIPE_API_KEY,

//     FIREBASE_API_KEY: process.env.REACT_APP_FIREBASE_API_KEY_DEV,
//     FIREBASE_AUTH_DOMAIN: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN_DEV,
//     FIREBASE_PROJECT_ID: process.env.REACT_APP_FIREBASE_PROJECT_ID_DEV,
//     FIREBASE_STORAGE_BUCKET: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_DEV,
//     FIREBASE_MESSAGE_SENDER_ID: process.env.REACT_APP_FIREBASE_MESSAGE_SENDER_ID_DEV,
//     FIREBASE_APP_ID: process.env.REACT_APP_FIREBASE_APP_ID_DEV,
//     FIREBASE_MEASUREMENT_ID: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_DEV,
// }

// const PROD_CONFIGURATIONS = {
//     API_BASE_URL: process.env.REACT_APP_API_BASE_URL_PROD,
//     API_BASE_DOMAIN: process.env.REACT_APP_API_BASE_DOMAIN_PROD,
//     API_BASE_SOCKET_DOMAIN: process.env.REACT_APP_API_BASE_SOCKET_DOMAIN_PROD,
//     API_PAYSTACK_BASE_URL: process.env.REACT_APP_PAYSTACK_BASE_URL_PROD,
//     API_PAYSTACK_PUBLIC_KEY: process.env.REACT_APP_PAYSTACK_PUBLIC_KEY_PROD,
//     API_PAYSTACK_SECRET_KEY: process.env.REACT_APP_PAYSTACK_SECRET_KEY_PROD,
//     REACT_APP_STRIPE_API_KEY: process.env.REACT_APP_STRIPE_API_KEY,

//     FIREBASE_API_KEY: process.env.REACT_APP_FIREBASE_API_KEY_PROD,
//     FIREBASE_AUTH_DOMAIN: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN_PROD,
//     FIREBASE_PROJECT_ID: process.env.REACT_APP_FIREBASE_PROJECT_ID_PROD,
//     FIREBASE_STORAGE_BUCKET: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_PROD,
//     FIREBASE_MESSAGE_SENDER_ID: process.env.REACT_APP_FIREBASE_MESSAGE_SENDER_ID_PROD,
//     FIREBASE_APP_ID: process.env.REACT_APP_FIREBASE_APP_ID_PROD,
//     FIREBASE_MEASUREMENT_ID: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_PROD,
// }

// const LOCAL_CONFIGURATIONS = {
//     API_BASE_URL: "http://127.0.0.1:5000/api/v1",
// };

// const CONFIGURATIONS =
//     process.env.NODE_ENV === "production"
//         ? PROD_CONFIGURATIONS
//         : process.env.NODE_ENV === "development"
//             ? DEV_CONFIGURATIONS
//             : LOCAL_CONFIGURATIONS;

// export { CONFIGURATIONS };

const CONFIGURATIONS = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  API_BASE_SOCKET_DOMAIN: process.env.REACT_APP_API_BASE_SOCKET_DOMAIN,
  REACT_APP_STRIPE_API_KEY: process.env.REACT_APP_STRIPE_API_KEY,
  UPLOAD_API_KEY: process.env.REACT_APP_UPLOAD_API_KEY,
  REACT_APP_CLODUFLARE_URL: process.env.REACT_APP_CLODUFLARE_URL,
  GTM_ID: process.env.REACT_APP_GTM_ID,
};

export { CONFIGURATIONS };
